// eslint-disable-next-line no-restricted-imports
import { asyncWithLDProvider } from 'launchdarkly-react-client-sdk';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { ENABLE_LAUNCHDARKLY, LDProviderConfig } from './services/launchDarkly';

const container = document.getElementById('root');
const root = createRoot(container!);

(async () => {
  if (!ENABLE_LAUNCHDARKLY) {
    root.render(<App />);
    return;
  }

  // Waits for the first flags (served from localStorage when cached, see
  // LDProviderConfig) so the first render has real values. The configured
  // timeout keeps a slow or unreachable LaunchDarkly from blocking the mount.
  const LDProvider = await asyncWithLDProvider(LDProviderConfig);

  root.render(
    <LDProvider>
      <App />
    </LDProvider>,
  );
})();
